import { render } from "./FiltroVeiculos.vue?vue&type=template&id=4f2f075e&scoped=true&ts=true"
import script from "./FiltroVeiculos.vue?vue&type=script&lang=ts"
export * from "./FiltroVeiculos.vue?vue&type=script&lang=ts"

import "./FiltroVeiculos.vue?vue&type=style&index=0&id=4f2f075e&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/indicar/indicar-gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f2f075e"]])

export default __exports__